module.exports = __webpack_public_path__ + "static/media/1.6358d17f.jpg";